<template>
  <div class="active-quiz-root">
    <div class="active-quiz-header">
      <h3>Pitanje {{ activeQuestionIndex + 1 + "/" + numberOfQuestions }}</h3>
      <div
        @click="onNextQuestionClick"
        class="main-btn next-question-btn"
        :class="{ disabled: selectedAnswer === null }"
      >
        {{ lastQuestionAnswered ? "Završi kviz" : "Sljedeće pitanje" }}
      </div>
    </div>
    <p class="question-category">
      {{ activeQuestionIndex < 5 ? "Termini" : "Mitovi i istine" }}
    </p>
    <ActiveQuestion
      :question="activeQuestion"
      :selected-answer="selectedAnswer"
      @answer-select="onAnswerSelect"
    />
    <div v-if="selectedAnswer !== null" class="correct-answer-explanation">
      <p>
        {{ activeQuestionExplanation }}
      </p>
    </div>
  </div>
</template>

<script>
import { computed, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { questionsData } from "../db/quiz-data";
import { filter, find } from "lodash";

import ActiveQuestion from "../components/ActiveQuestion.vue";
import { getAnalytics, logEvent } from 'firebase/analytics';

export default {
  name: "ActiveQuizView",
  components: {
    ActiveQuestion,
  },
  setup() {
    const analytics = getAnalytics();
    const route = useRoute();
    const router = useRouter();
    const quizId = computed(() => parseInt(route.params.quizId));
    const questionsDataList = computed(() => questionsData);
    const questionsDataListFiltered = computed(() =>
      filter(questionsDataList.value, (question) => {
        return question.quizId === quizId.value;
      })
    );
    const numberOfQuestions = computed(
      () => questionsDataListFiltered.value.length
    );
    const activeQuestionIndex = ref(0);
    const activeQuestion = computed(
      () => questionsDataListFiltered.value[activeQuestionIndex.value]
    );
    const activeQuestionExplanation = computed(
      () => find(activeQuestion.value.answers, { isCorrect: true }).explanation
    );
    const selectedAnswer = ref(null);
    const lastQuestionAnswered = computed(
      () =>
        selectedAnswer.value !== null &&
        activeQuestionIndex.value === numberOfQuestions.value - 1
    );
    const quizRezults = ref({
      correctAnswers: 0,
      wrongAnswers: 0,
    });

    const onAnswerSelect = ({ isAnswerCorrect, selectedAnswerIndex }) => {
      selectedAnswer.value = selectedAnswerIndex;
      if (isAnswerCorrect) {
        quizRezults.value.correctAnswers++;
      } else {
        quizRezults.value.wrongAnswers++;
      }
    };
    const onNextQuestionClick = () => {
      if (selectedAnswer.value === null) return;
      if (activeQuestionIndex.value < numberOfQuestions.value - 1) {
        activeQuestionIndex.value++;
        selectedAnswer.value = null;
      } else {
        goToResultsPage();
        logEvent(analytics, 'quiz_finished', { status: 'completed' });
      }
    };

    const goToResultsPage = () => {
      router.push({
        name: "quiz-results",
        query: {
          ...quizRezults.value,
        },
      });
    };
    return {
      activeQuestionIndex,
      numberOfQuestions,
      activeQuestion,
      selectedAnswer,
      lastQuestionAnswered,
      activeQuestionExplanation,
      onAnswerSelect,
      onNextQuestionClick,
      goToResultsPage,
    };
  },
};
</script>

<style lang="scss">
.active-quiz-root {
  min-height: 100vh;
  min-height: 100svh;
  color: #191414;
  padding: 0 30px;
  .active-quiz-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 30px;
    .next-question-btn {
      &.disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }
  .question-category {
    font-family: "Alumni Sans Pinstripe", sans-serif;
    font-size: 2rem;
    text-transform: uppercase;
    font-weight: bold;
    text-align: center;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
    letter-spacing: 0.5rem;
    font-weight: 800;
  }
  .correct-answer-explanation {
    max-width: 800px;
    margin: 3rem auto;
    text-align: center;
    font-style: italic;
    background-color: rgba(255, 255, 255, 0.7);
    padding: 1rem;
    border-radius: 8px;
    border: 2px solid #ede8e0;
  }
}
</style>
